// =============================================================
// Hằng số màn Quản lý chữ kí - port nguyên từ mobile-app-v2
// (src/modules/signature/signature.constant.ts) để nhãn/giá trị y hệt app.
// =============================================================

export const SIGNATURE_SOURCE_TYPE = {
  DRAWN: "DRAWN",
  PAPER: "PAPER",
};

export const SIGNATURE_STATUS = {
  ENABLE: "ENABLE",
  DISABLE: "DISABLE",
};

export const ALL_FILTER_VALUE = "ALL";

export const DEFAULT_SIGNATURE_LIMIT = 20;

export const SIGNATURE_TYPE_FILTER_OPTIONS = [
  { label: "Tất cả loại", value: ALL_FILTER_VALUE },
  { label: "Chữ kí số", value: SIGNATURE_SOURCE_TYPE.DRAWN },
  { label: "Chữ kí giấy", value: SIGNATURE_SOURCE_TYPE.PAPER },
];

export const SIGNATURE_STATUS_FILTER_OPTIONS = [
  { label: "Tất cả trạng thái", value: ALL_FILTER_VALUE },
  { label: "Đang hoạt động", value: SIGNATURE_STATUS.ENABLE },
  { label: "Ngừng hoạt động", value: SIGNATURE_STATUS.DISABLE },
];

export const SIGNATURE_CREATE_STATUS_OPTIONS = [
  { label: "Hoạt động", value: SIGNATURE_STATUS.ENABLE },
  { label: "Không hoạt động", value: SIGNATURE_STATUS.DISABLE },
];

export const SIGNATURE_CREATE_MODE_OPTIONS = [
  { label: "Kí số (vẽ)", value: SIGNATURE_SOURCE_TYPE.DRAWN },
  { label: "Upload chữ kí có sẵn", value: SIGNATURE_SOURCE_TYPE.PAPER },
];

export const getSourceTypeLabel = (sourceType) =>
  sourceType === SIGNATURE_SOURCE_TYPE.DRAWN ? "Chữ kí số" : "Chữ kí giấy";

export const getStatusLabel = (status) =>
  status === SIGNATURE_STATUS.ENABLE ? "Đang hoạt động" : "Ngừng hoạt động";
